module.exports = __webpack_public_path__ + "img/crop-simple.99d35f8d.svg";